import { useSelector } from 'react-redux';
import { selectMachines, selectSelectedItem } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackMachinePerformanceOpened = () => {
  const machines = useSelector(selectMachines) as Machine[];
  const selectedItem = useSelector(selectSelectedItem) as Machine;

  useTrackScreenOpened(TRACKING_EVENTS.MACHINE_PERFORMANCE, () => ({
    selectedPeriod: '',
    machineCount: machines?.length || 0,
    selectedMachineId: selectedItem?.machineId ? String(selectedItem.machineId) : undefined,
    selectedMachineName: selectedItem?.shortName || selectedItem?.fullName || undefined,
  }));
};
